// @flow
import {
  DELETE_IMMUNIZATION_LOADING,
  DELETE_IMMUNIZATION_SUCCESS,
  DELETE_IMMUNIZATION_ERROR,
  ADD_IMMUNIZATION_LOADING,
  ADD_IMMUNIZATION_SUCCESS,
  ADD_IMMUNIZATION_ERROR,
  UPDATE_IMMUNIZATION_LOADING,
  UPDATE_IMMUNIZATION_SUCCESS,
  UPDATE_IMMUNIZATION_ERROR,
} from '../actions/immunizationActions';

export default (state: Object = {}, action: Object) => {
  switch (action.type) {
    case DELETE_IMMUNIZATION_LOADING:
    case ADD_IMMUNIZATION_LOADING:
    case UPDATE_IMMUNIZATION_LOADING:
      return {
        ...state,
        status: 'LOADING',
      };
    case DELETE_IMMUNIZATION_SUCCESS:
    case ADD_IMMUNIZATION_SUCCESS:
    case UPDATE_IMMUNIZATION_SUCCESS:
      return {
        ...state,
        status: 'SUCCESS',
        data: action.data,
      };
    case DELETE_IMMUNIZATION_ERROR:
    case ADD_IMMUNIZATION_ERROR:
    case UPDATE_IMMUNIZATION_ERROR:
      return {
        ...state,
        status: 'ERROR',
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/immunizationReducer.js